export default __webpack_public_path__ + "static/media/s4.d76142b2.jpg";